import { INode } from "../../app/models/node";
import { SurveyDetailFormValues } from "../../app/models/survey";
import { RootStoreContext } from "../../app/stores/rootStore";
import { observer } from "mobx-react-lite";
import Tree from "rc-tree";
import React, { useContext, useEffect } from "react";
// reactstrap components
import { Modal, ModalBody, ModalHeader } from "reactstrap";
import MeetingTreeSurveyContext from "./MeetingTreeSurveyContext";
import TreeIcon from "../common/TreeIcon";
import classnames from "classnames";
import { useTranslation } from "react-i18next";
import { translationHookOptions } from "../../app/localization/localization";

interface IProps {
  isOpen: boolean;
  toggle: () => void;
  action: (key: string, title: string) => void;
  meetingId: number;
  form: SurveyDetailFormValues;
  selectedNode: string;
}

const AddNodeModal: React.FC<IProps> = ({
  isOpen,
  toggle,
  meetingId,
  action,
}) => {
  const rootStore = useContext(RootStoreContext);
  const { selectedLanguageId } = rootStore.commonStore;
  const { loadNodes, currentTree } = rootStore.meetingStore;
  const { theme } = rootStore.commonStore;
  const [t] = useTranslation(["surveys"], translationHookOptions);

  useEffect(() => {
    if (isOpen) loadNodes(meetingId, selectedLanguageId);

    return () => {};
  }, [isOpen, loadNodes, meetingId, selectedLanguageId]);

  const formatNodes = (tree: INode[]) => {
    let retArray: any[] = [];
    tree.forEach((node) => {
      let childrenNodes = formatNodes(node.children);
      retArray.push({
        key: node.key,
        title: (
          <MeetingTreeSurveyContext
            selectedNode={node}
            visible={false}
            meetingId={meetingId}
          />
        ),
        children: childrenNodes,
        icon: (
          <TreeIcon
            hasDocument={node.hasContent}
            markedAsNew={node.markAsNew}
            typology={node.typology}
          />
        ),
      });
    });
    return retArray;
  };

  let title: string = "";
  const getTitle = (tree: INode[], key: string) => {
    for (var i = 0; i < tree.length; i++) {
      if (tree[i].key === key) {
        title = tree[i].title;
        break;
      } else title = getTitle(tree[i].children, key);
    }

    return title;
  };

  if (!currentTree) return <></>;

  return (
    <>
      <Modal className="nodeModal" isOpen={isOpen} toggle={toggle} size="lg">
        <ModalHeader
          style={{ height: "10px" }}
          className={classnames(
            `${theme!.headerModal} ${theme!.headerTextColor}`
          )}
          toggle={toggle}
          close={
            <button
              className="closeModalIcon"
              onClick={() => toggle()}
            >
              <i className="far fa-times-circle fa-lg"></i>
            </button>
          }
        >
          <h5 className="modal-title nodeTitle" id="exampleModalLabel">
            {t("add_odg_doc_modal_title")}
          </h5>
        </ModalHeader>
        <ModalBody className="customModal ">
          <Tree
            defaultExpandAll={true}
            // draggable
            treeData={formatNodes(currentTree.tree)}
            onSelect={(selectedKeys, e) => {
              let title = getTitle(currentTree.tree, e.node.key.toString());
              action(e.node.key.toString(), title);
            }}
            showLine={true}
          />
        </ModalBody>
      </Modal>
    </>
  );
};

export default observer(AddNodeModal);
